import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import moment from 'moment';

@Component({
  selector: 'app-dialog-extract-data',
  templateUrl: './dialog-extract-data.component.html',
  styleUrls: ['./dialog-extract-data.component.scss'],
})
export class DialogExtractDataComponent implements OnInit {
  dateControl: FormControl;
  loading = false;
  maxDate = new Date();

  constructor(public dialogRef: MatDialogRef<DialogExtractDataComponent>) {
    const yesterday = moment().subtract(1, 'days');
    this.dateControl = new FormControl(yesterday, [Validators.required]);
  }

  ngOnInit(): void {}

  onConfirm(): void {
    if (this.dateControl.valid && !this.loading) {
      const formattedDate = moment(this.dateControl.value).format('YYYY-MM-DD');
      this.dialogRef.close({ date: formattedDate });
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
